// extracted by mini-css-extract-plugin
export default {"agendaSlotList__container":"AgendaSlotList-module__agendaSlotList__container___2nVuc"};